import React from 'react'
import "./footer.css"
function Footer() {
  return (
    <div className='footer'>
      Design and Code by  <span><a href="https://ashwin-portfolioo.netlify.app/"> Ashwin</a></span>
    </div>
  )
}

export default Footer
